<div class="facet-collection-wrapper">
  @if (facets['branchIds'] && facets['branchIds'].values?.length > 0) {
    <rn-expansion-panel>
      <h4 expansionHeader>Branches</h4>
      <rn-catalog-facets [facet]="facets['branchIds']" [searchTrigger]="filterChanged"/>
    </rn-expansion-panel>
  }
  @if (facets['materialTypeIds'] && facets['materialTypeIds'].values?.length > 0) {
    <rn-expansion-panel>
      <h4 expansionHeader>Material Type</h4>
      <rn-catalog-facets [facet]="facets['materialTypeIds']" [searchTrigger]="filterChanged"/>
    </rn-expansion-panel>
  }
  @if (facets['collectionIds'] && facets['collectionIds'].values?.length > 0) {
    <rn-expansion-panel>
      <h4 expansionHeader>Collections</h4>
      <rn-catalog-facets [facet]="facets['collectionIds']" [searchTrigger]="filterChanged"/>
    </rn-expansion-panel>
  }
  @if (facets['targetAudience'] && facets['targetAudience'].values?.length > 0) {
    <rn-expansion-panel>
      <h4 expansionHeader>Target Audience</h4>
      <rn-catalog-facets [facet]="facets['targetAudience']" [searchTrigger]="filterChanged"/>
    </rn-expansion-panel>
  }
  @if (facets['literaryForm'] && facets['literaryForm'].values?.length > 0) {
    <rn-expansion-panel>
      <h4 expansionHeader>Literary Form</h4>
      <rn-catalog-facets [facet]="facets['literaryForm']" [searchTrigger]="filterChanged"/>
    </rn-expansion-panel>
  }
  @if (facets['genres.keyword'] && facets['genres.keyword'].values?.length > 0) {
    <rn-expansion-panel>
      <h4 expansionHeader>Genres</h4>
      <rn-catalog-facets [facet]="facets['genres.keyword']" [searchTrigger]="filterChanged"/>
    </rn-expansion-panel>
  }
  @if (facets['subjects.keyword'] && facets['subjects.keyword'].values?.length > 0) {
    <rn-expansion-panel>
      <h4 expansionHeader>Subjects</h4>
      <rn-catalog-facets [facet]="facets['subjects.keyword']" [searchTrigger]="filterChanged"/>
    </rn-expansion-panel>
  }
  @if (facets['author.keyword'] && facets['author.keyword'].values?.length > 0) {
    <rn-expansion-panel>
      <h4 expansionHeader>Author</h4>
      <rn-catalog-facets [facet]="facets['author.keyword']" [searchTrigger]="filterChanged"/>
    </rn-expansion-panel>
  }
  @if (facets['publicationDate.keyword'] && facets['publicationDate.keyword'].values?.length > 0) {
    <rn-expansion-panel>
      <h4 expansionHeader>Publication Date</h4>
      <rn-catalog-facets [facet]="facets['publicationDate.keyword']" [searchTrigger]="filterChanged"/>
    </rn-expansion-panel>
  }
</div>
